import { ChevronDownIcon, MessageCircleQuestionIcon } from "lucide-react";
import type { WorkLogEntry } from "../../session-logic";
import { cn } from "../../lib/utils";
import { Collapsible, CollapsiblePanel, CollapsibleTrigger } from "../ui/collapsible";

export function UserInputHistory({
  input,
  open,
  onOpenChange,
}: {
  input: NonNullable<WorkLogEntry["userInput"]>;
  open: boolean;
  onOpenChange: () => void;
}) {
  const answered = input.status === "answered";
  const count = input.questions.length;
  const label = `${answered ? "Answered" : "Asked"} ${count === 1 ? "question" : `${count} questions`}`;
  return (
    <Collapsible open={open} onOpenChange={onOpenChange} className="min-w-0">
      <CollapsibleTrigger className="flex max-w-full items-center gap-2 rounded py-1 text-left text-sm leading-5 text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring">
        <MessageCircleQuestionIcon aria-hidden="true" className="size-4 shrink-0" />
        <span className="min-w-0 truncate">{label}</span>
        <ChevronDownIcon
          aria-hidden="true"
          className={cn("size-3.5 shrink-0 transition-transform", open && "rotate-180")}
        />
      </CollapsibleTrigger>
      <CollapsiblePanel>
        <section
          aria-label={answered ? "Submitted answers" : "Agent questions"}
          className="ml-2 mt-2 space-y-3 border-l border-border py-1 pl-4 text-sm"
        >
          {input.questions.map((question) => (
            <div key={question.id} className="space-y-1">
              <p className="whitespace-pre-wrap break-words">{question.question}</p>
              {question.answer !== undefined && (
                <p className="whitespace-pre-wrap break-words text-muted-foreground">
                  {question.answer}
                </p>
              )}
            </div>
          ))}
        </section>
      </CollapsiblePanel>
    </Collapsible>
  );
}
